// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Ku3JZCLRAogFIc {
  flex-shrink: 0;
  height: 32px;
  max-height: 32px;
  margin-right: var(--ds-space-050, 4px);
  margin-bottom: var(--ds-space-0, 0);
  margin-left: var(--ds-space-0, 0);
  line-height: 32px;
}
@media only screen and (max-width: 1540px) {
  .Ku3JZCLRAogFIc .HpsCFqZygiCyze {
    min-width: 32px;
    height: 32px;
    padding: var(--ds-space-075, 6px);
  }
}
@media only screen and (max-width: 1540px) {
  .Ku3JZCLRAogFIc ._5D5uSoxYw0qsk {
    margin-right: var(--ds-space-0, 0);
  }
}
@media only screen and (max-width: 1540px) {
  .Ku3JZCLRAogFIc .X_p3ULu7hHxp15 {
    display: none;
  }
}
.Ku3JZCLRAogFIc.G2m2zjp_Gj_ll6 .HpsCFqZygiCyze {
  min-width: 32px;
  height: 32px;
  padding: var(--ds-space-075, 6px);
}
.Ku3JZCLRAogFIc.G2m2zjp_Gj_ll6 ._5D5uSoxYw0qsk {
  margin-right: var(--ds-space-0, 0);
}
.Ku3JZCLRAogFIc.G2m2zjp_Gj_ll6 .X_p3ULu7hHxp15 {
  display: none;
}
.cuDnjU_MqLesGQ {
  margin-top: var(--ds-space-200, 16px);
  margin-bottom: var(--ds-space-200, 16px);
}
.pfg4_HilibJow1 {
  margin: var(--ds-space-100, 8px) var(--ds-space-0, 0px);
}
.WOz12eMz8QmE2a {
  margin-bottom: var(--ds-space-0, 0);
}
.mV5MGENwJiIvly {
  margin-right: var(--ds-space-050, 4px);
  margin-left: var(--ds-space-050, 4px);
}
.FTZXsv9D4JorRV {
  overflow: visible;
}
`, ""]);
// Exports
export var boardVisibilityContainer = `Ku3JZCLRAogFIc`;
export var boardVisibilityButton = `HpsCFqZygiCyze`;
export var boardVisibilityIcon = `_5D5uSoxYw0qsk`;
export var boardVisibilityText = `X_p3ULu7hHxp15`;
export var collapsed = `G2m2zjp_Gj_ll6`;
export var publicConfirmButton = `cuDnjU_MqLesGQ`;
export var divider = `pfg4_HilibJow1`;
export var shareLinkText = `WOz12eMz8QmE2a`;
export var shareLinkButton = `mV5MGENwJiIvly`;
export var inviteDialog = `FTZXsv9D4JorRV`;
export default ___CSS_LOADER_EXPORT___;
